'use strict';

/*
  FinancialAccount
  An object that represents a Financial Account resource. Data for this resource is stored through the
  Presenter/Model. Provides convenience methods for working with the resource.
  Parameters:
    presenter [APIPresenter] (required):
      Reference to the APIPresenter where the data for this bank account is stored.
    financialAccountModel [object] (required):
      Raw data from each visa_direct_financial_account model.
*/
function FinancialAccount(presenter, financialAccountModel) {
  this.presenter = presenter;
  this.id = financialAccountModel.id;

  this.accountsArrayIndex = null;

  this._getAccountArrayIndex = function () {
    if (this.accountsArrayIndex === null || this.presenter.getModelProperty('banking.financial_accounts[' + this.accountsArrayIndex + '].id') !== this.id) {
      var accounts = this.presenter.getModelProperty('banking.financial_accounts');
      for (var i = 0; i < accounts.length; i++) {
        if (accounts[i].id === this.id) {
          this.accountsArrayIndex = i;
          break;
        }
      }
    }
    return this.accountsArrayIndex;
  };

  this.deleteAccount = function (successCallback, failureCallback) {
    var index = this._getAccountArrayIndex();
    if (this.presenter.hasAction('banking.financial_accounts[' + index + '].delete_visa_direct_financial_account')) {
      this.presenter.performAction('banking.financial_accounts[' + index + '].delete_visa_direct_financial_account', null, function (data, response) {
        if (response === 200) {
          if (typeof successCallback === 'function') {
            successCallback(data);
          }
        } else if (typeof failureCallback === 'function') {
          failureCallback(data, response);
        }
      });
    } else {
      failureCallback({ errors: [{ code: 404, key: 'no_action_error' }] }, 404);
    }
  };

  this.getProperty = function (propertyName) {
    var index = this._getAccountArrayIndex();
    return this.presenter.getModelProperty('banking.financial_accounts[' + index + '].' + propertyName);
  };
}